function screencheck(mediasize) {
	// Genaral Global variables
	// "use strict";
	var $win = $(window);
	var $doc = $(document);
	var $winW = function(){ return $(window).width(); };
	var $winH = function(){ return $(window).height(); };
	// var $screensize = function(elm){  
	// 		return $(elm).width($winW()).height($winH());
	// 	};
		
  //var screencheck = function(mediasize){
    if (typeof window.matchMedia !== "undefined"){
      var screensize = window.matchMedia("(max-width:"+ mediasize+"px)");
      if( screensize.matches ) {
        return true;
      }else {
        return false;
      }
    } else { // for IE9 and lower browser
      if( $winW() <=  mediasize ) {
        return true;
      }else {
        return false;
      }
    }
  //};
}

export default screencheck;

//module.exports = bannerSlider;